import React from 'react';
import { X } from 'lucide-react';
import ModalPortal from '../ui/ModalPortal';

/**
 * Fenêtre du module « Requêtes » : même présentation que « Réparations et entretiens »
 * (fond assombri, en-tête rouge pâle, contenu défilant). Rendue en portail (sidebar).
 */
const FenetreRequete = ({ titre, sousTitre, badges, onClose, largeur = '760px', children, pied, zIndex = 100000 }) => (
  <ModalPortal>
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex',
        justifyContent: 'center', alignItems: 'center', zIndex, padding: '12px'
      }}
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        backgroundColor: 'white', borderRadius: '12px', width: '100%', maxWidth: largeur,
        maxHeight: '92vh', overflow: 'hidden', display: 'flex', flexDirection: 'column'
      }}>
        <div style={{
          padding: '16px 20px', borderBottom: '1px solid #e5e7eb', display: 'flex',
          justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px', backgroundColor: '#fef2f2'
        }}>
          <div style={{ minWidth: 0 }}>
            <h2 style={{ margin: 0, fontSize: '1.15rem', color: '#991b1b', display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
              <span>{titre}</span>
              {badges}
            </h2>
            {sousTitre && <p style={{ margin: '4px 0 0', color: '#64748b', fontSize: '0.875rem' }}>{sousTitre}</p>}
          </div>
          <button
            type="button" onClick={onClose} aria-label="X"
            style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px', color: '#475569' }}
          >
            <X size={20} />
          </button>
        </div>
        <div style={{ flex: 1, overflow: 'auto', padding: '16px 20px' }}>{children}</div>
        {pied && (
          <div style={{ padding: '12px 20px', borderTop: '1px solid #e5e7eb', display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            {pied}
          </div>
        )}
      </div>
    </div>
  </ModalPortal>
);

export const BadgeUrgent = ({ texte }) => (
  <span style={{ background: '#dc2626', color: 'white', borderRadius: '4px', padding: '2px 8px', fontSize: '0.7rem', fontWeight: 700 }}>
    {texte}
  </span>
);

export const BadgeStatut = ({ ouvert, texte }) => (
  <span style={{
    background: ouvert ? '#dcfce7' : '#e5e7eb', color: ouvert ? '#166534' : '#374151',
    borderRadius: '12px', padding: '2px 10px', fontSize: '0.75rem', fontWeight: 600
  }}>
    {texte}
  </span>
);

export const styleChamp = { width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '0.95rem', boxSizing: 'border-box' };
export const styleEtiquette = { display: 'block', fontWeight: 600, fontSize: '0.85rem', color: '#374151', marginBottom: '4px' };

export const BoutonRequete = ({ children, couleur = '#dc2626', contour = false, disabled, ...props }) => (
  <button
    type="button"
    disabled={disabled}
    {...props}
    style={{
      padding: '9px 16px', borderRadius: '8px', fontWeight: 600, fontSize: '0.9rem',
      cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1,
      background: contour ? 'white' : couleur, color: contour ? couleur : 'white',
      border: `1px solid ${couleur}`, ...(props.style || {})
    }}
  >
    {children}
  </button>
);

export default FenetreRequete;
